import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import AcademyFrame from '../../components/AcademyFrame';

export default function AppAcademy() {
  const navigate = useNavigate();
  const [dirty, setDirty] = useState(false);
  return (
    <main className="app-page academy-app-page">
      <header className="academy-portal-bar">
        <button type="button" className="academy-portal-back" onClick={() => {if (!dirty || window.confirm('Есть несохранённые изменения. Выйти без сохранения?')) navigate('/app');}} aria-label="Вернуться в портал">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m12 5-7 7 7 7M5 12h14" /></svg>
        </button>
        <h1 className="academy-portal-title">Академия Хэскета</h1>
        <span className="academy-portal-balance" aria-hidden="true" />
      </header>
      <AcademyFrame actor="app" onDirtyChange={setDirty} />
    </main>
  );
}
